(function () {
	const sliderBanner = () => {
		$(".slider-banner-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".slider-banner");

			if (box.find(".swiper-slide").length <= 1) {
				return;
			}

			const autoplay = box.data("autoplay");
			const delay = box.data("delay") * 1000;
			const speed = box.data("speed") * 1000;
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						disableOnInteraction: false,
						waitForTransition: true,
					},
				};
			} else {
				autoplayParm = {};
			}
			let swiperParms = {
				effect: box.data("effect"),
				speed: speed,
				loop: true,
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				mousewheel: {
					forceToAxis: true,
				},
				navigation: {
					nextEl: `#${id} .swiper-btn--next`,
					prevEl: `#${id} .swiper-btn--prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					renderBullet: function (index, className) {
						return '<span class="' + className + '">' + '0' + (index + 1) + "</span>";
				
					},
				},
				on: {
					init: function () {},
					slideChangeTransitionStart: function (swiper) {
						let bullets = document.querySelectorAll(
							`#${id} .swiper-pagination-bullet`
						);
						let activeIndex = swiper.realIndex;
		
							bullets.forEach((bullet, index) => {
								bullet.classList.remove("prev", "next");
								if (index === activeIndex - 1) {
									bullet.classList.add("prev");
								}
								if (index === activeIndex + 1) {
									bullet.classList.add("next");
								}
							});
						
						
					},
			
					slideNextTransitionStart: function () {
            let bullets = document.querySelector(
                `#${id} .swiper-pagination-bullet.next`
            );
					 let x =	document.querySelectorAll(`#${id} .swiper-pagination-bullet`);
						
						if(autoplay) {
							if (bullets) {
									bullets.classList.add('opacity-0');
									setTimeout(() => {
											bullets.classList.remove('opacity-0');
									}, speed);
							}
				
							//if ( x[x.length - 1].classList.contains('swiper-pagination-bullet-active'))   {

							//	setTimeout(() => {
							//		x[1].classList.remove('prev')
							//}, speed);
							//}
						}
				
        },


				slidePrevTransitionStart: function () {
					let bullets = document.querySelector(
							`#${id} .swiper-pagination-bullet.prev`
					);
					if(!autoplay) {
						if (bullets) {
								bullets.classList.add('opacity-0');
								setTimeout(() => {
										bullets.classList.remove('opacity-0');
								}, speed);
						}
					}
			},
				},
				...autoplayParm,
			};
			const swiper = new Swiper(`#${id} .slider-banner__swiper`, swiperParms);

			if (window.innerWidth <= 990) {
				function swipedetect(el, callback) {
					var touchsurface = el,
						swipedir,
						startX,
						startY,
						distX,
						distY,
						threshold = 100, //required min distance traveled to be considered swipe
						restraint = 300, // maximum distance allowed at the same time in perpendicular direction
						allowedTime = 300, // maximum time allowed to travel that distance
						elapsedTime,
						startTime,
						handleswipe = callback || function (swipedir) {};

					touchsurface.addEventListener(
						"touchstart",
						(e) => {
							var touchobj = e.changedTouches[0];
							swipedir = "none";
							dist = 0;
							startX = touchobj.pageX;
							startY = touchobj.pageY;
							startTime = new Date().getTime(); // record time when finger first makes contact with surface
						},
						{ passive: true }
					);

					touchsurface.addEventListener("touchend", (e) => {
						var touchobj = e.changedTouches[0];
						distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
						distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
						elapsedTime = new Date().getTime() - startTime; // get time elapsed

						if (elapsedTime <= allowedTime) {
							// first condition for swipe met
							if (
								Math.abs(distX) >= threshold &&
								Math.abs(distY) <= restraint
							) {
								// 2nd condition for horizontal swipe met
								swipedir = distX < 0 ? "left" : "right"; // if dist traveled is negative, it indicates left swipe
							}
						}

						handleswipe(swipedir);
					});
				}

				swipedetect(this, (swipedir) => {
					if (swipedir === "left") {
						swiper.slideNext();
					}

					if (swipedir === "right") {
						swiper.slidePrev();
					}
				});
			}
		});
	};

	sliderBanner()
	document.addEventListener('shopify:section:load', function () {
		sliderBanner()
	})
})();
